import { render, staticRenderFns } from "./editsightings.vue?vue&type=template&id=285cff42"
import script from "./editsightings.vue?vue&type=script&lang=js"
export * from "./editsightings.vue?vue&type=script&lang=js"
import style0 from "./editsightings.vue?vue&type=style&index=0&id=285cff42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports